import { useCallback } from 'react'

import { VisibleIcon, NotVisibleIcon } from '../../Icons/Icons'
import ListButton from './ListButton'

const ShowButton = ({ visible, onChange }) => {
  const handleClick = useCallback(
    (e) => {
      if (onChange) {
        onChange(!visible)
      }
    },
    [visible, onChange]
  )

  return (
    <ListButton
      tooltipTitle={visible ? 'Ocultar' : 'Mostrar'}
      tooltipEnabled
      onClick={handleClick}
    >
      {visible ? <VisibleIcon /> : <NotVisibleIcon />}
    </ListButton>
  )
}
export default ShowButton
